import PropTypes from "prop-types";
import React from "react";
import { fetchIsPublicCollection } from "../../utils/apis";

import { Flex, Text, Modal, useMantineTheme } from "@mantine/core";

import CustomButton from "../mantineCustomComponents/CustomButton";
const IsPublicCollectionWindow = ({
  collectionID,
  isPublic,
  setNameCollectionIsPinned,
  openedModalPublic,
  onOpenedModalPublic,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  // Pinned Collection name
  const handleClickIsPublicCollection = async () => {
    try {
      await fetchIsPublicCollection(
        collectionID,
        isPublic,
        onOpenedModalPublic,
        setNameCollectionIsPinned,
      );
    } catch (e) {
      // optionally log or handle error
    }
  };

  return (
    <Modal
      opened={openedModalPublic}
      onClose={() => onOpenedModalPublic(false)}
      centered
      size="22rem"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
    >
      <Text
        classNames={{
          root: isPublic ? "modal-text-pinned" : "modal-text-unpinned",
        }}
      >
        {isPublic
          ? "You can make this Collection public"
          : "You can make this Collection private"}
      </Text>

      <Text
        styles={() => ({
          root: {
            fontSize: "1.5em",
            textAlign: "center",
            marginTop: "1em",
            marginBottom: "1em",
          },
        })}
      >
        Proceed?
      </Text>

      <Flex
        justify={theme.flex.justify.center}
        gap={theme.flex.gap.large}
        mb={theme.margin.xl}
      >
        <CustomButton
          text="Yes"
          componentClasses="buttonBlack modal-button-submit"
          onClick={() => handleClickIsPublicCollection()}
        ></CustomButton>
        <CustomButton
          text="No"
          componentClasses="buttonWhite"
          onClick={() => onOpenedModalPublic(false)}
        ></CustomButton>
      </Flex>
    </Modal>
  );
};

IsPublicCollectionWindow.propTypes = {
  collectionID: PropTypes.string,
  isPublic: PropTypes.bool.isRequired,
  setNameCollectionIsPinned: PropTypes.func.isRequired,
  openedModalPublic: PropTypes.bool.isRequired,
  onOpenedModalPublic: PropTypes.func.isRequired,
};
export default IsPublicCollectionWindow;
